import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../Context/MyProvider';
import ImageLoad from './ImageLoad';
import Logo from "../image/astrotalk-logo.png";
import { useTranslation } from 'react-i18next';

const Header = () => {

  const { t, i18n } = useTranslation();

  const { BaseUrl, setIsToast, setToastMsg, setUserLogin, userlogin, isauth, setIsAuth, formatPrice } = useContext(MyContext);

  const [profilepic, setProfilePic] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [ismenubox, setISMenuBox] = useState(false);
  const [ismenu, setIsMenu] = useState(false);
  const [isLngBox, setIsLngBox] = useState(false);
  const [activeLng, setActiveLng] = useState("en");

  const navigate = useNavigate();
  const Currency = secureLocalStorage.getItem("currency") || "$";
  const isShow = secureLocalStorage.getItem("modulsshow");

  const LanguageList = [
    { id: 1, title: "English", key: "en" },
    { id: 2, title: "Hindi", key: "hi" },
    { id: 3, title: "Spanish", key: "sp" },
    { id: 4, title: "Arabic", key: "ar" },
    { id: 5, title: "Bengali", key: "bn" },
    { id: 6, title: "Portuguese", key: "pt" },
    { id: 7, title: "Russian", key: "ru" },
    { id: 8, title: "Japanese", key: "ja" },
    { id: 9, title: "Punjabi", key: "pa" },
    { id: 10, title: "German", key: "ge" },
    { id: 11, title: "French", key: "fr" },
    { id: 12, title: "Urdu", key: "ur" },
    { id: 13, title: "Indonesian", key: "in" },
    { id: 14, title: "Marathi", key: "mr" },
    { id: 15, title: "Gujarati", key: "gu" },
    { id: 16, title: "Chinese (Simplified)", key: "ch" }
  ]

  useEffect(() => {
    const LocalData = secureLocalStorage.getItem("Logindata");
    if (LocalData && LocalData !== "null" && LocalData !== "undefined") {
      try {
        const Data = typeof LocalData === 'string' ? JSON.parse(LocalData) : LocalData;
        if (Data) {
          setProfilePic(Data.profile || "");
          setName(Data.name || "");
          setEmail(Data.email || "");
        }
      } catch (e) {
        console.error("Error parsing Logindata in Header:", e);
      }
    }

    setActiveLng(secureLocalStorage.getItem("I18"));

  }, [userlogin]);

  const handleNavigate = (path) => {
    navigate(path);
    setISMenuBox(false);
    if (ismenu) {
      setIsMenu(false);
    }
  }

  const handleLogout = () => {
    setIsToast(true);
    setToastMsg("Logout Seccuessfuly !!");
    setISMenuBox(false);
    setIsAuth(false);
    setUserLogin(prev => prev + 1);
    secureLocalStorage.removeItem("isAuthenticated");
    secureLocalStorage.removeItem("Userid");
    secureLocalStorage.removeItem("tex");
    secureLocalStorage.removeItem("Logindata");
    secureLocalStorage.removeItem("currency");
    sessionStorage.clear();
    if (ismenu) {
      setIsMenu(false);
    }
    window.location.href = "/";
  }

  const handleSelectLanguage = (key) => {
    setActiveLng(key);
    i18n.changeLanguage(key);
    secureLocalStorage.setItem("I18", key);
    setIsLngBox(false);
  }

  return (
    <div>
      <div className="header_page shadow-sm">
        <div className="width_container">
          <div className="flex items-center justify-between">

            <div className='flex items-center gap-3 select-none'>
              <img src={Logo} className='w-[42px] h-[42px] object-cover rounded-full shadow-sm hover:scale-105 transition-transform duration-300' alt="Logo" />
              <Link to="/" className="text-[26px] font-[700] tracking-[-0.03em] text-slate-800 hover:opacity-90 transition-opacity flex items-center max-_425_:text-[20px]">
                <span>Astro</span>
                <span className="text-[#FA6400]">Space</span>
              </Link>
            </div>

            <div className="px-[10px] max-_1024_:hidden">
              <ul className='flex items-center gap-[25px]'>
                {isShow === "true" && <li className='nav_link'>
                  <Link to="/kundli-matching">
                    {t("Kundli Matching")}
                  </Link>
                </li>}
                {isShow === "true" && <li className='nav_link'>
                  <Link to="/freekundli">
                    {t("Free Kundli")}
                  </Link>
                </li>}
                {isShow === "true" && <li className='nav_link'>
                  <Link to="/horoscope">
                    {t("Horoscope")}
                  </Link>
                </li>}
                <li className='nav_link max-_1200_:hidden'>
                  <Link to="/recent-post">
                    {t("Recent Post")}
                  </Link>
                </li>
                <li className='nav_link max-_1200_:hidden'>
                  <Link to="/chat-width-astrologer">
                    {t("Chat With Astrologer")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="right_box">

              {isauth && <Link to="/wallet" className="flex items-center gap-2 bg-gray-100 py-[5px] px-[10px] rounded-[50px] max-_425_:hidden">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" className="text-white bg-[--bgcolor] p-[5px] rounded-full" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>
                <span className='font-medium text-[15px] me-1'> {formatPrice(secureLocalStorage.getItem("userwallet") || 0, 2)}</span>
              </Link>}

              <div className="relative">

                <div onClick={() => setISMenuBox(!ismenubox)} className="flex items-center gap-[10px] cursor-pointer">
                  <div className="w-9 h-9 ">
                    <ImageLoad url={profilepic ? BaseUrl + profilepic : ""} alt="Photo" CustomeStyle="w-full h-full object-cover border-[1px] border-gray-400 rounded-full" />
                  </div>
                  <svg width="10" height="6" className={`duration-[.2s] ${ismenubox ? "rotate-180" : "rotate-0"}`} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.74978 5.50076C4.55778 5.50076 4.36575 5.42778 4.21975 5.28079L0.21975 1.28079C-0.07325 0.987785 -0.07325 0.51275 0.21975 0.21975C0.51275 -0.07325 0.987785 -0.07325 1.28079 0.21975L4.75076 3.68972L8.22073 0.21975C8.51373 -0.07325 8.98876 -0.07325 9.28176 0.21975C9.57476 0.51275 9.57476 0.987785 9.28176 1.28079L5.28176 5.28079C5.13376 5.42778 4.94178 5.50076 4.74978 5.50076Z" fill="#25314C" />
                  </svg>
                </div>

                {ismenubox && <div className="absolute top-[50px] -left-[140px] z-[200]">
                  <div className="menu_box">

                    <div className="px-4 py-4 bg-blue-50 border-b border-gray-100">
                      <div className="flex items-center gap-[10px]">
                        <div className="w-12 h-12 ">
                          <ImageLoad url={profilepic ? BaseUrl + profilepic : ""} alt="Photo" CustomeStyle="w-full h-full object-cover border-[1px] border-gray-400 rounded-full" />
                        </div>
                        <div className='leading-5'>
                          <p className="font-bold text-gray-900 text-[17px]">{name ? name.slice(0, 1).toUpperCase() + name.slice(1) : "User"}</p>
                          <p className="text-[14px] text-gray-600">{email || "User@gmail.com"}</p>
                        </div>
                      </div>
                    </div>

                    <div onClick={() => handleNavigate("/dashboard")} className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group">
                      <div className="text-blue-600 group-hover:bg-blue-100 p-[8px] rounded-[10px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                      </div>
                      <span className="font-medium text-gray-700 group-hover:text-gray-900">{t("Dashboard")}</span>
                    </div>

                    {isauth && <div onClick={() => handleNavigate("/profile")} className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group">
                      <div className="text-purple-600 group-hover:bg-purple-100 p-[8px] rounded-[10px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                      </div>
                      <span className="font-medium text-gray-700 group-hover:text-gray-900">{t("My Profile")}</span>
                    </div>}

                    <div onClick={() => setIsLngBox(!isLngBox)} className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group">
                      <div className="text-orange-600 group-hover:bg-orange-100 p-[8px] rounded-[10px]">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 1.25C6.072 1.25 1.25 6.073 1.25 12C1.25 17.927 6.072 22.75 12 22.75C17.928 22.75 22.75 17.927 22.75 12C22.75 6.073 17.928 1.25 12 1.25ZM21.25 12C21.25 12.034 21.245 12.067 21.245 12.101C20.797 12.206 20.348 12.435 20 12.791C19.848 12.67 19.5 12.309 18.937 11.27C18.315 10.123 18.562 9.58999 18.936 8.78299C19.063 8.50999 19.188 8.23499 19.28 7.95099C19.427 7.51599 19.403 6.93799 19.298 6.33499C20.516 7.90299 21.25 9.865 21.25 12ZM2.75 12C2.75 11.51 2.79899 11.033 2.87299 10.564C3.74599 13.072 5.705 14.066 6.797 14.617C6.981 14.71 7.19897 14.82 7.31897 14.895C7.36697 15.162 7.35902 15.35 7.34302 15.677C7.32802 16.004 7.30899 16.412 7.33899 17.047C7.39899 18.282 8.40302 18.807 9.13702 19.19C9.57702 19.42 9.99397 19.637 10.207 19.952C10.314 20.105 10.413 20.585 10.378 21.098C6.04999 20.329 2.75 16.547 2.75 12ZM11.868 21.243C11.931 20.428 11.781 19.583 11.444 19.102C11.025 18.483 10.392 18.152 9.83301 17.861C9.08901 17.472 8.85399 17.299 8.83899 16.976C8.81199 16.408 8.83002 16.042 8.84302 15.749C8.86302 15.327 8.88 14.962 8.75 14.403C8.623 13.858 8.116 13.602 7.474 13.278C6.113 12.592 3.85503 11.444 3.93903 7.479C5.52603 4.66 8.54198 2.75 12.001 2.75C12.394 2.75 12.779 2.78299 13.16 2.83099C12.999 3.04199 12.769 3.21701 12.533 3.29401C10.466 3.97101 10.444 5.809 10.429 7.026C10.417 8.047 10.351 8.23301 10.202 8.26801C10.077 8.25901 9.72499 8.06899 9.51599 7.95499C8.97899 7.66299 8.42502 7.36101 7.84802 7.50101C7.37202 7.61301 6.79297 8.05501 6.60797 8.68301C6.51597 8.99501 6.45099 9.61301 7.04999 10.234C7.41199 10.609 7.425 10.756 7.453 11.049C7.474 11.273 7.50403 11.579 7.66803 11.955C8.29903 13.349 10.192 13.134 10.912 13.05C12.03 12.91 12.232 12.904 12.793 13.488C13.021 13.725 13.154 14.027 13.294 14.347C13.561 14.953 13.925 15.783 15.052 15.913C15.932 16.022 16.496 16.299 16.665 16.526C16.706 16.581 16.716 16.619 16.705 16.683C16.652 16.997 16.258 17.372 15.801 17.807C15.043 18.527 14.039 19.493 13.676 21.092C13.132 21.192 12.573 21.252 12 21.252C11.955 21.25 11.912 21.244 11.868 21.243ZM15.439 20.58C15.789 19.893 16.315 19.385 16.834 18.892C17.459 18.298 18.048 17.738 18.185 16.93C18.264 16.461 18.155 16.01 17.869 15.627C17.241 14.784 15.951 14.51 15.232 14.421C14.996 14.394 14.933 14.341 14.669 13.741C14.5 13.356 14.289 12.876 13.876 12.447C12.777 11.303 11.871 11.416 10.735 11.559C9.36299 11.715 9.08998 11.453 9.03998 11.343C8.97598 11.197 8.96497 11.081 8.94897 10.906C8.90097 10.399 8.80198 9.88601 8.13098 9.19101C8.07498 9.13301 8.05201 9.093 8.04901 9.103C8.06501 9.06 8.15399 8.977 8.13599 8.966C8.25699 8.977 8.59699 9.162 8.79999 9.272C9.33299 9.562 9.88499 9.86 10.464 9.741C11.902 9.445 11.918 8.057 11.93 7.043C11.947 5.665 12.053 5.02899 13.001 4.71899C13.691 4.49299 14.382 3.91301 14.693 3.15201C15.502 3.39901 16.26 3.757 16.958 4.203C17.449 4.957 18.047 6.91899 17.858 7.48099C17.782 7.71499 17.679 7.93401 17.577 8.15201C17.159 9.05301 16.639 10.175 17.62 11.985C18.467 13.546 19.147 14.248 19.895 14.334C19.936 14.339 19.983 14.342 20.036 14.342C20.303 14.342 20.7 14.256 21.065 13.85C20.438 16.919 18.285 19.435 15.439 20.58Z" fill="currentColor" />
                        </svg>
                      </div>
                      <span className="font-medium text-gray-700 group-hover:text-gray-900">{t("Languages")}</span>
                    </div>

                    {isauth && <div onClick={handleLogout} className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group hover:bg-red-50">
                      <div className="text-red-600 group-hover:bg-red-100 p-[8px] rounded-[10px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="m16 17 5-5-5-5"></path>
                          <path d="M21 12H9"></path>
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        </svg>
                      </div>
                      <span className="font-medium text-red-600">{t("Logout")}</span>
                    </div>}

                    {!isauth && <Link to="/auth/login" onClick={() => setISMenuBox(false)} className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group hover:bg-orange-50">
                      <div className="text-orange-600 group-hover:bg-orange-100 p-[8px] rounded-[10px]">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.75 6V18C21.75 20.418 20.418 21.75 18 21.75H12C9.582 21.75 8.25 20.418 8.25 18V17C8.25 16.586 8.586 16.25 9 16.25C9.414 16.25 9.75 16.586 9.75 17V18C9.75 19.577 10.423 20.25 12 20.25H18C19.577 20.25 20.25 19.577 20.25 18V6C20.25 4.423 19.577 3.75 18 3.75H12C10.423 3.75 9.75 4.423 9.75 6V7C9.75 7.414 9.414 7.75 9 7.75C8.586 7.75 8.25 7.414 8.25 7V6C8.25 3.582 9.582 2.25 12 2.25H18C20.418 2.25 21.75 3.582 21.75 6ZM12.47 14.47C12.177 14.763 12.177 15.238 12.47 15.531C12.616 15.677 12.808 15.751 13 15.751C13.192 15.751 13.384 15.678 13.53 15.531L16.53 12.531C16.599 12.462 16.654 12.379 16.692 12.287C16.768 12.104 16.768 11.897 16.692 11.714C16.654 11.622 16.599 11.539 16.53 11.47L13.53 8.47C13.237 8.177 12.762 8.177 12.469 8.47C12.176 8.763 12.176 9.23801 12.469 9.53101L14.189 11.251H3C2.586 11.251 2.25 11.587 2.25 12.001C2.25 12.415 2.586 12.751 3 12.751H14.189L12.47 14.47Z"
                            stroke="currentColor"
                            strokeWidth="0.5"
                            strokeLinejoin="round"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                      <span className="font-medium text-orange-600">{t("Login")}</span>
                    </Link>}
                  </div>
                </div>}

                {ismenubox && <div onClick={() => setISMenuBox(false)} className="fixed inset-0 z-[150]"></div>}

              </div>
            </div>
          </div>
        </div>
      </div>

      {isLngBox && <div className="model items-center justify-center z-[9999]">
        {/* Backdrop overlay for closing the modal */}
        <div className="fixed inset-0 bg-black/40 backdrop-blur-[3px] transition-opacity duration-300" onClick={() => setIsLngBox(false)}></div>
        
        {/* Modal content box */}
        <div className="relative w-[400px] max-w-[calc(100%-32px)] bg-white rounded-[20px] shadow-2xl flex flex-col overflow-hidden border border-slate-100 z-10 modal-scale-in">
          
          {/* Header */}
          <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 bg-white">
            <h2 className="font-bold text-[18px] text-slate-800">{t("Select Language")}</h2>
            <button onClick={() => setIsLngBox(false)} className="text-slate-400 hover:text-slate-600 hover:bg-slate-100 p-1.5 rounded-full transition-all duration-200">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          {/* Body List */}
          <div className="max-h-[50vh] overflow-y-auto p-5 space-y-2 scroll_container bg-white">
            {LanguageList.map((item, index) => {
              const isActive = item.key === activeLng;
              return (
                <div 
                  key={index} 
                  onClick={() => handleSelectLanguage(item.key)} 
                  className={`w-full flex items-center justify-between border-[1.5px] p-3.5 rounded-[12px] cursor-pointer transition-all duration-200 hover:scale-[1.01] ${isActive ? "border-[#FA6400] bg-orange-50/30" : "border-slate-100 hover:border-slate-300 hover:bg-slate-50/50"}`}
                >
                  <span className={`font-semibold text-[15px] ${isActive ? "text-[#FA6400]" : "text-slate-700"}`}>{item.title}</span>
                  <div className={`w-[20px] h-[20px] rounded-full border-[2px] flex items-center justify-center transition-all duration-200 ${isActive ? "border-[#FA6400] bg-white" : "border-slate-300 bg-white"}`}>
                    <div className={`w-[10px] h-[10px] rounded-full transition-all duration-200 ${isActive ? "bg-[#FA6400]" : "bg-transparent"}`}></div>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>}

    </div>
  )
}

export default Header